var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWhiteExpense(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_136",
    "data-name": "Group 136",
    transform: "translate(0 -0.405)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_127",
    "data-name": "Rectangle 127",
    width: 20,
    height: 20,
    transform: "translate(0 0.405)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_112",
    "data-name": "Group 112",
    transform: "translate(2.771 1.405)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_236",
    "data-name": "Path 236",
    d: "M1704.824,1475.6a1.348,1.348,0,0,0-1.34-1.245h-.22a1.432,1.432,0,0,0-1.427,1.427v3.342a.36.36,0,0,0,.36.36h2.632V1475.7C1704.829,1475.663,1704.826,1475.63,1704.824,1475.6Z",
    transform: "translate(-1701.836 -1474.34)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_237",
    "data-name": "Path 237",
    d: "M1728.51,1474.293h-8.5a2.6,2.6,0,0,1,.444,1.458v14.82a.568.568,0,0,0,.545.586h9.166a.568.568,0,0,0,.545-.586v-14.046A2.221,2.221,0,0,0,1728.51,1474.293Zm-2.366,5.849a3.922,3.922,0,0,0-.74-.254,6.447,6.447,0,0,1-.913-.314,1.642,1.642,0,0,1-.625-.5,1.431,1.431,0,0,1-.266-.909,1.6,1.6,0,0,1,.419-1.1,2.033,2.033,0,0,1,1.107-.619v-.917h1.047v.885a3.642,3.642,0,0,1,.808.213,2,2,0,0,1,.605.358l-.426,1.045a3.129,3.129,0,0,0-.733-.382,2.128,2.128,0,0,0-.711-.132.937.937,0,0,0-.55.145.472.472,0,0,0-.206.41.41.41,0,0,0,.131.309.887.887,0,0,0,.325.193q.195.068.554.165a6.31,6.31,0,0,1,.9.289,1.5,1.5,0,0,1,.613.49,1.477,1.477,0,0,1,.254.909,1.6,1.6,0,0,1-.415,1.11,2,2,0,0,1-1.119.6v.909h-1.047v-.877a3.512,3.512,0,0,1-.894-.189,2.548,2.548,0,0,1-.714-.382l.426-1.045a2.69,2.69,0,0,0,1.571.506q.823,0,.823-.563A.379.379,0,0,0,1726.144,1480.142Zm-4.317,9.593a.542.542,0,1,1,.5-.54A.523.523,0,0,1,1721.827,1489.734Zm0-1.972a.542.542,0,1,1,.5-.54A.523.523,0,0,1,1721.827,1487.762Zm0-1.972a.542.542,0,1,1,.5-.54A.523.523,0,0,1,1721.827,1485.79Zm6.285,3.924h-4.65a.521.521,0,0,1,0-1.04h4.65a.521.521,0,0,1,0,1.04Zm-5.134-2.492a.5.5,0,0,1,.483-.52h3.422a.521.521,0,0,1,0,1.04h-3.422A.5.5,0,0,1,1722.978,1487.222Zm5.953-1.452h-5.469a.521.521,0,0,1,0-1.04h5.469a.521.521,0,0,1,0,1.04Z",
    transform: "translate(-1716.498 -1474.293)",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhiteExpense);
export default __webpack_public_path__ + "static/media/white_expense.231554cdba8f06962a761f5390c43317.svg";
export { ForwardRef as ReactComponent };